import { Theme, Typography } from '@mui/material';

import { Icon } from '@/components/Icon';

import { useTranslate } from '@/hooks/useTranslate';

import { SecurityInfoContainer } from './SecurityInfo.styled';

export const SecurityInfo = () => {
  const { t } = useTranslate();
  return (
    <SecurityInfoContainer>
      <Icon
        name="lock"
        size={24}
        color={(theme: Theme) => theme.palette.neutral[300]}
      />
      <Typography variant="caption">
        {t('onboardingGuide.protectData')}
      </Typography>
    </SecurityInfoContainer>
  );
};
